import { z } from "zod";
import { revokePaymentDecisionSchema } from "./payments";
const defaultValidationTranslate = (key, params) => {
    const fallbackMessages = {
        required: "This field is required",
        invalidEmail: "Invalid email address",
        minLength: `Minimum length is ${params?.min ?? 1} characters`,
    };
    return fallbackMessages[key] ?? key;
};
export const addressSchema = z.object({
    street: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    postalCode: z.string().optional(),
    country: z.string().optional(),
});
export function createMemberFormSchema(t = defaultValidationTranslate) {
    return z.object({
        firstName: z.string().min(1, t("required")),
        lastName: z.string().min(1, t("required")),
        email: z.email(t("invalidEmail")),
        phoneNumber: z.string().min(10, t("minLength", { min: 10 })).optional(),
        dateOfBirth: z.string().optional(),
        gender: z.enum(["male", "female"]).optional(),
        address: addressSchema.optional(),
    });
}
export const memberFormSchema = createMemberFormSchema();
export const addMemberToClubSchema = z.object({
    userId: z.string().min(1, "User ID is required"),
    clubId: z.number().min(1, "Club ID is required"),
});
export const revokeMembershipSchema = z
    .object({
    userId: z.string().min(1, "User ID is required"),
    clubId: z.number().min(1, "Club ID is required"),
    paymentDecisions: z.array(revokePaymentDecisionSchema).optional(),
})
    .superRefine((value, context) => {
    const ids = (value.paymentDecisions ?? []).map((decision) => decision.paymentId);
    if (new Set(ids).size !== ids.length) {
        context.addIssue({
            code: "custom",
            path: ["paymentDecisions"],
            message: "Each payment can have only one decision",
        });
    }
});
export const validateMembershipSchema = z.object({
    userId: z.string().min(1, "User ID is required"),
    clubId: z.number().optional(),
});
export const recordAttendanceSchema = z.object({
    userId: z.string().min(1, "User ID is required"),
    clubId: z.number().min(1, "Club ID is required"),
});
